import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { filter, map, take } from "rxjs/operators";

import { AppState } from "../../../store/reducers";
import { MpCommonSelectors } from "../../../store/selectors/mp-common.selectors";

@Injectable()
export class ActiveUserGuard {
	constructor(
		private store: Store<AppState>,
		private router: Router
	) {}

	canActivate(): Observable<boolean | UrlTree> {
		return this.store.select(MpCommonSelectors.userStatus).pipe(
			filter((state) => !state.loading),
			take(1),
			map((state) => {
				const nonActiveStatuses = [
					"REQUEST_VENDOR_OWNER",
					"REQUEST_CONSUMER_OWNER",
					"DISABLED_CONSUMER_USER",
					"DISABLED_VENDOR_USER",
					"DENIED_CONSUMER_OWNER",
					"DENIED_VENDOR_OWNER",
					"PENDING_VENDOR_USER",
					"PENDING_CONSUMER_USER"
				];
				if (nonActiveStatuses.includes(state.status)) {
					return this.router.parseUrl("/app/pending");
				}
				return true;
			})
		);
	}
}
